import { ChipProps } from "@mui/material";
import { LicenseEventType } from "../../clients/answeringClient";
import { ResellerClientOrigin } from "../controllers/ResellerManagementController";

/** Props para Chip de ação (cor + rótulo) */
export function getEventChipProps(t: LicenseEventType): {
  label: string;
  color: ChipProps["color"];
} {
  switch (t) {
    case "ASSIGN":
      return { label: "Distribuição", color: "primary" };
    case "REVOKE":
      return { label: "Revogação", color: "warning" };
    default:
      return { label: t, color: "default" };
  }
}

/** Origem do vínculo → rótulo em PT-BR */
export function getOriginLabel(origin?: ResellerClientOrigin): string {
  if (origin === "INVITED_NEW_USER") return "Convidado";
  return "Já tinha conta";
}
